import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import './header-shelf.css';
import Logo from './logo.png';
// import Avatar from './avatar.jpeg';
import Avatar from './photo.jpeg';
import defaultAvatar from './user-icon.png';

export default class HeaderShelf extends Component {
  constructor(props) {
    super(props);

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.handleProfileClick = this.handleProfileClick.bind(this);

    this.state = {
      searchValue: '',
      userName: '',
      userAvatar: defaultAvatar,
      render_dropdown: false,
      render_video: false
    };
  }

  // componentWillMount() {
  //   if (window.localStorage.getItem("super-app-biblioteca-senac-v4-video-intro-is-rendered") === null) {
  //     this.setState({
  //       "render_video": true
  //     });
  //   }
  // }

  componentDidMount() {
    this.loadUserName();
  }

  loadUserName = async () => {
    try {
      const userDetails = await Sdk.Api.dynamic.bridge('/auth/v1.0/user/me', null, 'GET');
      const userName = userDetails.detail.name || 'Usuário';
      const userAvatar = this.getUserAvatar(userDetails.detail);

      this.setState({
        userName,
        userAvatar
      });
    } catch (error) {
      console.error('Error loading user data:', error);
      this.setState({ userName: 'Usuário', userAvatar: defaultAvatar });
    }
  }

  getUserAvatar = (userDetail) => {
    // Tentar obter avatar do usuário seguindo padrão do js_app_senac
    if (userDetail.avatar) {
      return userDetail.avatar;
    }

    // Fallback para avatar padrão
    return defaultAvatar;
  }

  handleSearchChange(event) {
    this.setState({
      searchValue: event.target.value
    });
  }

  handleNotificationClick() {
    // Handle notification click
    console.log('Notification clicked');
  }

  handleProfileClick() {
    this.setState({
      "render_dropdown": !this.state.render_dropdown
    })
  }

  renderSearchIcon() {
    return (
      <svg
        className="header-shelf-search-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
          stroke="#005496"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  renderNotificationIcon() {
    return (
      <svg
        className="header-shelf-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={this.handleNotificationClick}
      >
        <path
          d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
          stroke="#1D2951"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
          stroke="#1D2951"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  renderUserIcon() {
    return (
      <svg
        className="header-shelf-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
          stroke="#1D2951"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
          stroke="#1D2951"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    const {
      userName,
      searchValue,
      render_dropdown,
      userAvatar,
      render_video
    } = this.state;

    const {
      renderSearch = true,
      isUserLoggedIn = true,
      onLoginClick
    } = this.props;

    return (
      <header className="header-shelf" role="banner">
        <div className="header-shelf-left">
          <img
            src={Logo}
            alt="Logo Senac"
            className="header-shelf-logo"
            onClick={() => this.redirectTo("/")}
            role="button"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                if (e.key === ' ') e.preventDefault();
                this.redirectTo("/");
              }
            }}
          />
          <div className="header-shelf-text">
            <p>Editora<br></br>Senac<br></br>São Paulo</p>
          </div>
        </div>

        {renderSearch &&
          <div className="header-shelf-center">
            <div
              className="header-shelf-search-container"
              onClick={() => this.props.onSearchClick()}
              role="button"
              tabIndex="0"
              aria-label="Pesquisar"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  if (e.key === ' ') e.preventDefault();
                  this.props.onSearchClick();
                }
              }}
            >
              {this.renderSearchIcon()}
              <input
                type="text"
                placeholder="Encontre aqui o seu livro"
                // placeholder="Descubra títulos com ajuda da IA"
                className="header-shelf-search-input"
                value={searchValue}
                onChange={this.handleSearchChange}
                aria-label="Buscar livros"
              />
            </div>
          </div>
        }

        <div className="header-shelf-right">
          {isUserLoggedIn ? (
            <>
              {/* {this.renderNotificationIcon()} */}
              {/* {this.renderUserIcon()} */}
              {/* <button className="header-shelf-news-btn">Conheça a nova Biblioteca</button> */}
              <span className="header-shelf-welcome">Olá, {userName.split(" ")[0]}!</span>
              <img 
                src={userAvatar}
                alt="Foto de perfil - Menu do usuário"
                className="header-shelf-profile"
                onClick={this.handleProfileClick}
                role="button"
                tabIndex="0"
                aria-haspopup="true"
                aria-expanded={render_dropdown}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    if (e.key === ' ') e.preventDefault();
                    this.handleProfileClick();
                  }
                }}
              />

              {render_dropdown &&
                <ul className="header-shelf-dropdown" role="menu">
                  <li
                    className="header-shelf-dropdown-item"
                    onClick={() => window.location.hash = '/user/profile'}
                    role="menuitem"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        if (e.key === ' ') e.preventDefault();
                        window.location.hash = '/user/profile';
                      }
                    }}
                  >
                    Meus dados
                  </li>
                  <li
                    className="header-shelf-dropdown-item"
                    onClick={() => window.location.hash = '/user/change'}
                    role="menuitem"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        if (e.key === ' ') e.preventDefault();
                        window.location.hash = '/user/change';
                      }
                    }}
                  >
                    Alterar senha
                  </li>
                  <li
                    className="header-shelf-dropdown-item"
                    onClick={() => this.props.onSignOut()}
                    role="menuitem"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        if (e.key === ' ') e.preventDefault();
                        this.props.onSignOut();
                      }
                    }}
                  >
                    Sair
                  </li>
                </ul>
              }
            </>
          ) : (
            <button className="header-shelf-login-btn" onClick={()=> this.redirectTo('/login')}>
              Entrar
            </button>
          )}
        </div>

        {/* {render_video &&
          <div className="header-shelf-video-modal">
            <div className="header-shelf-video-modal-overlay"></div>
            <div className="header-shelf-video-modal-content">
              <div className="header-shelf-video-modal-content-header">
                <video></video>
              </div>
            </div>
          </div>
        } */}
      </header>
    );
  }
}
